// SN-19877: the patient's Medicare policy, as Anvil fills it (`medicare_*` aliases): the latest active
// *primary* policy whose policy type is Medicare (`Patient.primary_medicare_insurance_policy`). It
// offers exactly the primary policy's tags, so it is derived from that group rather than copied.
import {
  PATIENT_PRIMARY_INSURANCE_POLICY_MENU_OPTIONS,
  PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS
} from "./patient-primary-insurance-policy.utils";
import { type MergeTagMenuEntry } from "./signature-merge-tags.utils";

export const toMedicareTag = (primaryTag: string) =>
  primaryTag.replace(
    "Patient.PrimaryInsurancePolicy.",
    "Patient.MedicareInsurancePolicy."
  );

export const PATIENT_MEDICARE_INSURANCE_POLICY_OPTIONS = Object.fromEntries(
  Object.entries(PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS).map(
    ([key, value]) => [
      key.replace(/^PRIMARY_/, "MEDICARE_"),
      toMedicareTag(value)
    ]
  )
) as Record<string, string>;

const toMedicareEntry = (entry: MergeTagMenuEntry): MergeTagMenuEntry => ({
  title: entry.title.replace(
    "Primary Insurance Policy",
    "Medicare Insurance Policy"
  ),
  ...(entry.value && { value: toMedicareTag(entry.value) }),
  ...(entry.menu && { menu: entry.menu.map(toMedicareEntry) })
});

export const PATIENT_MEDICARE_INSURANCE_POLICY_MENU_OPTIONS = toMedicareEntry(
  PATIENT_PRIMARY_INSURANCE_POLICY_MENU_OPTIONS
);
